import {
  ArrowDropDown,
  Delete,
  Edit,
  Image,
  InsertDriveFile,
  Preview,
} from "@mui/icons-material";
import {
  Button,
  IconButton,
  ListItem,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import React, { useContext, useMemo, useState } from "react";
import DeleteDocument from "./Modals/DeleteDocument";
import ApprovalChecklist from "./ApprovalChecklist";
import DataContext from "../../../../../../../../context/DataContext";
import DocumentUpdateListItem from "./DocumentUpdateListItem";
import CaseSummaryContext from "../../../CaseSummaryV2/context/CaseSummaryContext";
import ModalShell from "../../../../../../../global/ModalShell";
import AssociateAppointments from "./Modals/AssociateAppointments";
import PropTypes from "prop-types";
import { ClientDetailContext } from "../../../context/ClientDetailContext";

export default function DocumentListItem({
  document,
  documentTypeObj,
  setViewDocument,
  setActiveDoc,
  editDoc,
  truncate,
  docTrigger,
  setDocTrigger,
  docTypeOptions,
  docValidation,
  docSourceOptions,
  clientId,
  activeProvObj,
}) {
  const { userRoles } = useContext(DataContext);
   const {
        isLaunchedFromAppointmentsTab,
        setIsLaunchedFromAppointmentsTab,
      } = useContext(ClientDetailContext);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAssociateAppointmentsModal, setOpenAssociateAppointmentsModal] =
    useState(false);
  const [editType, setEditType] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const canViewAssociatedDocuments = userRoles.permissions.includes(
    "filemanager.view_document_association"
  );

  const handleClickActionMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectAction = (action) => {
    handleCloseActionMenu();
    if (action === "associateDocuments") {
      setIsLaunchedFromAppointmentsTab(false);
      setOpenAssociateAppointmentsModal(true);
      
    }
  };

  function getExtension(filename) {
    if (filename.includes(".")) {
      return filename.split(".").pop();
    } else {
      return "";
    }
  }
  const photoExtensions = ["png", "jpg", "jpeg"];

  const handleOpenDocument = (document) => {
    setViewDocument(true);
    setActiveDoc(document);
  };

  const displayCountAssociatedDocuments = useMemo(
    () =>
      document.provider_total_appointment_count
        ? `${document.associated_appointment_count}/${document.provider_total_appointment_count}`
        : "N/A",
    [
      document.associated_appointment_count,
      document.provider_total_appointment_count,
    ]
  );

  return (
    <>
      {editType ? (
        <DocumentUpdateListItem
          document={document}
          documentTypeObj={documentTypeObj}
          setActiveDoc={setActiveDoc}
          setViewDocument={setViewDocument}
          editDoc={editDoc}
          docTypeOptions={docTypeOptions}
          docValidation={docValidation}
          truncate={truncate}
          docTrigger={docTrigger}
          setDocTrigger={setDocTrigger}
          editType={editType}
          setEditType={setEditType}
          clientId={clientId}
          activeProvObj={activeProvObj}
        />
      ) : (
        <ListItem style={{ padding: "0 16px" }}>
          <div
            style={{
              borderBottom: "1px solid #EBEBEB",
              padding: "5px 0px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              style={{ display: "flex", alignItems: "center", width: "70%" }}
            >
              <div
                style={{
                  textAlign: "left",
                  fontSize: "14px",
                  alignSelf: "center",
                  width: "20%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ alignSelf: "center" }}>
                  <Tooltip title={document.file_name}>
                    <span>
                      {" "}
                      {photoExtensions.includes(
                        getExtension(document.file_name)
                      ) ? (
                        <Image />
                      ) : (
                        <InsertDriveFile />
                      )}
                    </span>
                  </Tooltip>
                </div>
                <Tooltip
                  title={
                    photoExtensions.includes(getExtension(document.file_name))
                      ? "View Image"
                      : "View Document"
                  }
                >
                  <IconButton onClick={() => handleOpenDocument(document)}>
                    <Preview style={{ color: "#1976d2" }} />
                  </IconButton>
                </Tooltip>
                {!documentTypeObj
                  ? ""
                  : documentTypeObj[document.document_type]}{" "}
              </div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  alignSelf: "center",
                  width: "20%",
                }}
              >
                <Tooltip title={new Date(document.created_at).toLocaleString()}>
                  <span>
                    Created:{new Date(document.created_at).toLocaleDateString()}
                  </span>
                </Tooltip>
                <br />
                <Tooltip title={new Date(document.updated_at).toLocaleString()}>
                  <span>
                    Updated:{" "}
                    {new Date(document.updated_at).toLocaleDateString()}
                  </span>
                </Tooltip>
              </div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  alignSelf: "center",
                  width: "20%",
                }}
              >
                <strong>Created by:</strong>{" "}
                {!document.created_by_name
                  ? "Unknown"
                  : document.created_by_name}
                <br />
                <strong>Updated by:</strong> {document.updated_by_name}
              </div>
              {document.referral_to ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    alignSelf: "center",
                    width: "25%",
                  }}
                >
                  <strong>To:</strong> {document.referral_to_name}
                  <br />
                  <strong>From:</strong> {document.referral_from_name}
                </div>
              ) : document.provider ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    alignSelf: "center",
                    width: "25%",
                  }}
                >
                  {document.provider_name}
                </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    alignSelf: "center",
                    width: "25%",
                  }}
                ></div>
              )}
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  alignSelf: "center",
                  width: "15%",
                }}
                className="show-count-related-appoiments"
              >
                {displayCountAssociatedDocuments}
              </div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  alignSelf: "center",
                  width: "15%",
                }}
              >
                {document.source
                  ? docSourceOptions.map((g) =>
                      g.value === document.source ? g.display_name : ""
                    )
                  : " "}
              </div>
            </div>

            <div style={{ display: "flex", width: "30%" }}>
              {canViewAssociatedDocuments && (
                <div className="mr-4 flex items-center">
                  <Button
                    className="capitalize text-sm"
                    id="action-button"
                    aria-controls={!!anchorEl ? "action-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={!!anchorEl || undefined}
                    onClick={handleClickActionMenu}
                    endIcon={<ArrowDropDown />}
                  >
                    Actions
                  </Button>
                  <Menu
                    id="action-menu"
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={handleCloseActionMenu}
                    MenuListProps={{
                      "aria-labelledby": "action-button",
                    }}
                  >
                    <MenuItem
                      className="text-sm"
                      onClick={() => handleSelectAction("associateDocuments")}
                    >
                      Associate Documents
                    </MenuItem>
                    <MenuItem
                      className="text-sm"
                      onClick={() => handleSelectAction()}
                    >
                      Audit Appointments
                    </MenuItem>
                  </Menu>
                </div>
              )}
              {userRoles.permissions.includes(
                "filemanager.view_documentapproval"
              ) ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                    alignSelf: "center",
                    width: "75%",
                  }}
                >
                  <ApprovalChecklist
                    document={document}
                    docTrigger={docTrigger}
                    setDocTrigger={setDocTrigger}
                  />
                </div>
              ) : (
                ""
              )}
              <div
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  alignSelf: "center",
                  width: "auto",
                  display: "flex",
                }}
              >
                {userRoles.permissions.includes(
                  "filemanager.delete_document"
                ) ? (
                  <div style={{ marginRight: "12px" }}>
                    <Tooltip placement="right" title={"Delete"}>
                      <span>
                        <IconButton onClick={() => setOpenDeleteModal(true)}>
                          <Delete style={{ color: "red" }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
                {userRoles.permissions.includes(
                  "filemanager.change_document"
                ) ? (
                  <div>
                    <Tooltip placement="left" title={"Edit"}>
                      <span>
                        <IconButton onClick={() => setEditType(true)}>
                          <Edit />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {!openDeleteModal ? (
            ""
          ) : (
            <DeleteDocument
              document={document}
              openDeleteModal={openDeleteModal}
              setOpenDeleteModal={setOpenDeleteModal}
              getExtension={getExtension}
              docTrigger={docTrigger}
              setDocTrigger={setDocTrigger}
              documentTypeObj={documentTypeObj}
            />
          )}
        </ListItem>
      )}
      {openAssociateAppointmentsModal && (
        <ModalShell
          open
          setOpen={setOpenAssociateAppointmentsModal}
          fullWidth
          customWidth="xl"
        >
          <AssociateAppointments
            clientId={clientId}
            document={document}
            setOpenAssociateAppointmentsModal={
              setOpenAssociateAppointmentsModal
            }
            docTrigger={docTrigger}
            setDocTrigger={setDocTrigger}
            isLaunchedFromAppointmentsTab={isLaunchedFromAppointmentsTab}
          />
        </ModalShell>
      )}
    </>
  );
}

DocumentListItem.propTypes = {
  document: PropTypes.shape({
    associated_appointment_count: PropTypes.number,
    provider_total_appointment_count: PropTypes.number,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  documentTypeObj: PropTypes.any,
  setViewDocument: PropTypes.func,
  setActiveDoc: PropTypes.func,
  editDoc: PropTypes.bool,
  truncate: PropTypes.any,
  docTrigger: PropTypes.any,
  setDocTrigger: PropTypes.func,
  docTypeOptions: PropTypes.any,
  docValidation: PropTypes.any,
  docSourceOptions: PropTypes.any,
  clientId: PropTypes.any,
  activeProvObj: PropTypes.any,
};
